export default __webpack_public_path__ + "static/media/Hulu.04188fd1.svg";